// Allow inline styles for images:
import Image from '@tiptap/extension-image'
import Paragraph from '@tiptap/extension-paragraph'
import BulletList from '@tiptap/extension-bullet-list'
import OrderedList from '@tiptap/extension-ordered-list'
import Table from '@tiptap/extension-table'
import TableRow from '@tiptap/extension-table-row'
import Link from '@tiptap/extension-link'

// Allow inline styles for images:
const StyleImage = Image.extend({
	addAttributes () {
		return {
			...this.parent?.(),
			style: {
				default: null,
				renderHTML: attributes => {
					if (! attributes.style) {
						return
					}

					return {
						style: `${attributes.style}`
					}
				}
			}
		}
	}
})

// Allow inline styles for paragraphs:
const StyleParagraph = Paragraph.extend({
	addAttributes () {
		return {
			...this.parent?.(),
			style: {
				default: null,
				renderHTML: attributes => {
					if (! attributes.style) {
						return
					}

					return {
						style: `${attributes.style}`
					}
				}
			}
		}
	}
})

// Allow inline styles for lists:
const StyleBulletList = BulletList.extend({
	addAttributes () {
		return {
			...this.parent?.(),
			style: {
				default: null,
				renderHTML: attributes => {
					if (! attributes.style) {
						return
					}

					return {
						style: `${attributes.style}`
					}
				}
			}
		}
	}
})

// Allow inline styles for lists:
const StyleOrderedList = OrderedList.extend({
	addAttributes () {
		return {
			...this.parent?.(),
			style: {
				default: null,
				renderHTML: attributes => {
					if (! attributes.style) {
						return
					}

					return {
						style: `${attributes.style}`
					}
				}
			}
		}
	}
})

// Allow attr for tables:
const StyleTable = Table.extend({
	addAttributes () {
		return {
			...this.parent?.(),
			style: {
				default: null,
				renderHTML: attributes => {
					if (! attributes.style) {
						return
					}

					return {
						style: `${attributes.style}`
					}
				}
			},
			class: {
				default: null,
				renderHTML: attributes => {
					if (! attributes.class) {
						return
					}

					return {
						class: `${attributes.class}`
					}
				}
			},
			width: {
				default: null,
				renderHTML: attributes => {
					if (! attributes.width) {
						return
					}

					return {
						width: `${attributes.width}`
					}
				}
			},
			border: {
				default: null,
				renderHTML: attributes => {
					if (! attributes.border) {
						return
					}

					return {
						border: `${attributes.border}`
					}
				}
			},
			cellpadding: {
				default: null,
				renderHTML: attributes => {
					if (! attributes.cellpadding) {
						return
					}

					return {
						cellpadding: `${attributes.cellpadding}`
					}
				}
			},
			cellspacing: {
				default: null,
				renderHTML: attributes => {
					if (! attributes.cellspacing) {
						return
					}

					return {
						cellspacing: `${attributes.cellspacing}`
					}
				}
			},
			align: {
				default: null,
				renderHTML: attributes => {
					if (! attributes.align) {
						return
					}

					return {
						align: `${attributes.align}`
					}
				}
			}
		}
	}
})
const StyleTableRow = TableRow.extend({
	addAttributes () {
		return {
			...this.parent?.(),
			style: {
				default: null,
				renderHTML: attributes => {
					if (! attributes.style) {
						return
					}

					return {
						style: `${attributes.style}`
					}
				}
			},
			class: {
				default: null,
				renderHTML: attributes => {
					if (! attributes.class) {
						return
					}

					return {
						class: `${attributes.class}`
					}
				}
			},
			width: {
				default: null,
				renderHTML: attributes => {
					if (! attributes.width) {
						return
					}

					return {
						width: `${attributes.width}`
					}
				}
			},
			border: {
				default: null,
				renderHTML: attributes => {
					if (! attributes.border) {
						return
					}

					return {
						border: `${attributes.border}`
					}
				}
			},
			cellpadding: {
				default: null,
				renderHTML: attributes => {
					if (! attributes.cellpadding) {
						return
					}

					return {
						cellpadding: `${attributes.cellpadding}`
					}
				}
			},
			cellspacing: {
				default: null,
				renderHTML: attributes => {
					if (! attributes.cellspacing) {
						return
					}

					return {
						cellspacing: `${attributes.cellspacing}`
					}
				}
			},
			align: {
				default: null,
				renderHTML: attributes => {
					if (! attributes.align) {
						return
					}

					return {
						align: `${attributes.align}`
					}
				}
			}
		}
	}
})

// Allow inline styles for links:
const StyleLink = Link.extend({
	addAttributes () {
		return {
			...this.parent?.(),
			style: {
				default: null,
				renderHTML: attributes => {
					if (! attributes.style) {
						return
					}

					return {
						style: `${attributes.style}`
					}
				}
			},
			class: {
				default: null,
				renderHTML: attributes => {
					if (! attributes.class) {
						return
					}

					return {
						class: `${attributes.class}`
					}
				}
			}
		}
	}
}).configure({
	openOnClick: false
})

export {
	StyleImage,
	StyleParagraph,
	StyleBulletList,
	StyleOrderedList,
	StyleTable,
	StyleTableRow,
	StyleLink
}
